import type { ReactNode } from 'react';
import React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Text } from '@balance-web/text';
import { Box } from '@balance-web/box';
export type LabelProps = {
  children: ReactNode;
};

export const GroupTitle = ({ children }: LabelProps) => {
  return (
    <DropdownMenuPrimitive.Label>
      <Box paddingX="small">
        <Text color="textBody" size="xsmall">
          {children}
        </Text>
      </Box>
    </DropdownMenuPrimitive.Label>
  );
};
